<template>
    <div>
        <div class="position-relative" v-if="adminSummaryPermissions">
            <app-overlay-loader v-if="preloader"/>
            <div class="row mb-primary" :class="{'loading-opacity': preloader}">
                <div class="col-sm-6 col-lg-3 mb-4 mb-lg-0 kpi-clickable" v-if="$can('view_employees')" @click="openKpi('employees')">
                    <app-widget
                        type="app-widget-with-icon"
                        :label="$t('total_employees')"
                        :number="numberFormatter(cardSummaries.total_employee)"
                        icon="user"
                    />
                </div>
                <div class="col-sm-6 col-lg-3 mb-4 mb-lg-0 kpi-clickable" v-if="$can('view_departments')" @click="openKpi('departments')">
                    <app-widget
                        type="app-widget-with-icon"
                        :label="$t('total_departments')"
                        :number="numberFormatter(cardSummaries.total_department)"
                        icon="home"
                    />
                </div>
                <div class="col-sm-6 col-lg-3 mb-4 mb-sm-0 kpi-clickable" v-if="$can('view_all_leaves')" @click="openKpi('leave_requests')">
                    <app-widget
                        type="app-widget-with-icon"
                        :label="$t('total_leave_requests')"
                        :number="numberFormatter(cardSummaries.total_leave_request)"
                        icon="edit"
                    />
                </div>
                <div class="col-sm-6 col-lg-3 kpi-clickable" v-if="$can('view_all_leaves')" @click="openKpi('on_leave_today')">
                    <app-widget
                        type="app-widget-with-icon"
                        :label="$t('on_leave_today')"
                        :number="numberFormatter(cardSummaries.on_leave_today)"
                        icon="user-x"
                    />
                </div>
            </div>
        </div>

        <div class="position-relative mb-primary" v-if="hasKpis">
            <app-overlay-loader v-if="kpiLoader"/>
            <div class="row" :class="{'loading-opacity': kpiLoader}">
                <div class="col-sm-6 col-lg-3 mb-4 kpi-clickable" v-if="kpis.present_today != null" @click="openKpi('present_today')">
                    <app-widget type="app-widget-with-icon"
                                :label="`Present today · ${kpis.attendance_rate}%`"
                                :number="numberFormatter(kpis.present_today)" icon="user-check"/>
                </div>
                <div class="col-sm-6 col-lg-3 mb-4 kpi-clickable" v-if="kpis.late_today != null" @click="openKpi('late_today')">
                    <app-widget type="app-widget-with-icon" label="Late arrivals today"
                                :number="numberFormatter(kpis.late_today)" icon="clock"/>
                </div>
                <div class="col-sm-6 col-lg-3 mb-4 kpi-clickable" v-if="kpis.new_joiners != null" @click="openKpi('new_joiners')">
                    <app-widget type="app-widget-with-icon" label="New joiners this month"
                                :number="numberFormatter(kpis.new_joiners)" icon="user-plus"/>
                </div>
                <div class="col-sm-6 col-lg-3 mb-4 kpi-clickable" v-if="kpis.pending_approvals != null" @click="openKpi('pending_approvals')">
                    <app-widget type="app-widget-with-icon" label="Pending approvals"
                                :number="numberFormatter(kpis.pending_approvals)" icon="inbox"/>
                </div>
                <div class="col-sm-6 col-lg-3 mb-4 kpi-clickable" v-if="kpis.avg_attendance != null" @click="openKpi('avg_attendance')">
                    <app-widget type="app-widget-with-icon" label="Avg attendance this month"
                                :number="`${kpis.avg_attendance}%`" icon="activity"/>
                </div>
                <div class="col-sm-6 col-lg-3 mb-4 kpi-clickable" v-if="kpis.birthdays != null" @click="openKpi('birthdays')">
                    <app-widget type="app-widget-with-icon" label="Birthdays this month"
                                :number="numberFormatter(kpis.birthdays)" icon="gift"/>
                </div>
                <div class="col-sm-6 col-lg-3 mb-4 kpi-clickable" v-if="kpis.anniversaries != null" @click="openKpi('anniversaries')">
                    <app-widget type="app-widget-with-icon" label="Work anniversaries"
                                :number="numberFormatter(kpis.anniversaries)" icon="award"/>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-9 mb-4 mb-md-0" v-if="employeeStatisticsPermissions">
                <app-employee-statistics/>
            </div>
            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3" v-if="attendancePermissions">
                <on-working-today/>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-12 col-md-6 col-lg-4">
                <upcoming-birthdays/>
            </div>
        </div>

        <app-kpi-detail-modal v-if="kpiModalOpen" v-model="kpiModalOpen" :kpi-key="kpiModalKey"/>
    </div>
</template>

<script>
import {numberFormatter} from "../../../../../common/Helper/Support/SettingsHelper";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";
import {APP_DASHBOARD, CHECK_DEFAULT_WORKING_SHIFT} from "../../../../Config/ApiUrl";
import OnWorkingToday from "./OnWorkingToday";
import UpcomingBirthdays from "./UpcomingBirthdays";

export default {
    name: "AdminDashboard",
    components: {UpcomingBirthdays, OnWorkingToday},
    data() {
        return {
            numberFormatter,
            preloader: false,
            cardSummaries: {},
            kpis: {},
            kpiLoader: false,
            kpiModalOpen: false,
            kpiModalKey: null,
        }
    },
    created() {
        this.getSummeryData();
        if (this.adminSummaryPermissions || this.attendancePermissions) {
            this.getKpis();
        }
    },
    methods: {
        getSummeryData() {
            this.preloader = true;
            axiosGet(`${APP_DASHBOARD}/summery`).then(({data}) => {
                this.cardSummaries = data;
                this.preloader = false;
            })
        },
        getKpis() {
            this.kpiLoader = true;
            axiosGet(`${APP_DASHBOARD}/experience-kpis`).then(({data}) => {
                this.kpis = data;
            }).finally(() => {
                this.kpiLoader = false;
            })
        },
        openKpi(key) {
            this.kpiModalKey = key;
            this.kpiModalOpen = true;
        },
    },
    computed: {
        hasKpis() {
            return Object.keys(this.kpis).some(k => this.kpis[k] != null);
        },
        adminSummaryPermissions() {
            return this.$can('view_employees') ||
                this.$can('view_departments') || this.$can('view_all_leaves')
        },
        employeeStatisticsPermissions() {
            return this.$can('view_employment_statuses') ||
                this.$can('view_designations') || this.$can('view_departments')
        },
        attendancePermissions() {
            return this.$can('view_all_attendance')
        }
    }
}
</script>

<style scoped>
.kpi-clickable {
    cursor: pointer;
}

.kpi-clickable :deep(.dashboard-widgets) {
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.kpi-clickable:hover :deep(.dashboard-widgets) {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(8, 32, 92, 0.12);
}
</style>